import React from "react";
import { Container, Row, Card, CardBody, Table } from "reactstrap";
import Slider from "react-slide-out";
import "react-slide-out/lib/index.css";
import * as env from "../../../../env";
import { columnHeader } from "./config";
import Pagination from "../../../../shared/components/pagination/Pagination";
import FormComponent from "./form";
import MoreActions from "./MoreActions";
import { Link } from "react-router-dom";
import client from "../../../../shared/api-client";
import Modal from "../../../../shared/modal";
import * as validate from "../../../../shared/validate";

class ResidentialProxies extends React.Component {
  state = {
    title: "Residential Proxies",
    addTitle: "Add Residential Proxy",
    editTitle: "Edit Residential Proxy",
    isOpen: false,
    results: [],
    filteredResults: [],
    columnHeader: columnHeader,
    filters: [],
    startIndex: 0,
    endIndex: env.RECORDS_PER_PAGE,
    show: false,
    success: "",
    errors: [],
    formValues: { slug: "", name: "" },
  };

  getResults() {
    client(`residentialProxies.php`).then(
      (response) => {
        this.setResults(response);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  handleForm = (formValues) => {
    this.setState({ formValues }, () => {
      // Validations will be added here if required frontend validations
    });
  };

  submit = () => {
    let method = "PUT";

    let errors = [];

    if (
      this.state.formValues.name === undefined ||
      !validate.required(this.state.formValues.name)
    ) {
      errors.push("Please enter the name.");
    }

    if (
      this.state.formValues.link === undefined ||
      !validate.required(this.state.formValues.link)
    ) {
      errors.push("Please enter the link.");
    }

    if (
      this.state.formValues.bandwidth === undefined ||
      !validate.required(this.state.formValues.bandwidth)
    ) {
      errors.push("Please enter the bandwidth.");
    }

    if (
      this.state.formValues.price === undefined ||
      !validate.required(this.state.formValues.price)
    ) {
      errors.push("Please enter the price.");
    }

    if (
      this.state.formValues.username === undefined ||
      !validate.required(this.state.formValues.username)
    ) {
      errors.push("Please enter the username.");
    }

    if (
      this.state.formValues.password === undefined ||
      !validate.required(this.state.formValues.password)
    ) {
      errors.push("Please enter the password.");
    }

    if (errors.length > 0) {
      this.setState({
        show: true,
        success: "",
        errors: errors,
      });

      return false;
    }

    if (
      this.state.editable !== undefined &&
      this.state.editable.id !== undefined
    ) {
      method = "POST";
    }

    client(`residentialProxies.php`, {
      method: method,
      body: {
        id:
          this.state.formValues.id !== undefined ? this.state.formValues.id : 0,
        type: "residential",
        link: this.state.formValues.link,
        name: this.state.formValues.name,
        price: this.state.formValues.price,
        bandwidth: this.state.formValues.bandwidth,
        dedicated_account_manager: this.state.formValues
          .dedicated_account_manager,
        over_100_countries: this.state.formValues.over_100_countries,
        residential_static: this.state.formValues.residential_static,
        residential_rotating: this.state.formValues.residential_rotating,
        locations: this.state.formValues.locations,
        username: this.state.formValues.username,
        password: this.state.formValues.password,
      },
    }).then(
      (response) => {
        this.getResults();
        this.toggleAddNew();
      },
      (error) => {
        this.setState({
          show: true,
          errors: error._user_message,
          success: "",
        });
      }
    );
  };

  setResults = (results) => {
    this.setState({
      isOpen: false,
      results: results,
      filteredResults: results,
    });
  };

  componentDidMount() {
    this.getResults();
  }

  formChangeHandler = (event) => {
    let filters = this.state.filters;
    let filter = { name: event.target.name, value: event.target.value };

    var foundIndex = filters.findIndex((x) => x.name === filter.name);

    if (foundIndex >= 0) {
      filters[foundIndex] = filter;
    } else {
      filters.push(filter);
    }

    this.setState({ filters });
    this.filterResults();
  };

  filterResults = () => {
    let filteredResults = this.state.results;

    this.state.filters.forEach((element, index) => {
      if (element.value.trim() !== "") {
        switch (element.name) {
          case "id":
            filteredResults = filteredResults.filter((o) =>
              Object.keys(o).some((k) =>
                String(o[element.name])
                  .toLowerCase()
                  .includes(element.value.toLowerCase())
              )
            );
            break;
          default:
            filteredResults = filteredResults.filter((o) =>
              Object.keys(o).some((k) =>
                o[element.name]
                  .toLowerCase()
                  .includes(element.value.toLowerCase())
              )
            );
        }
      }
    });

    this.setState({ filteredResults });
  };

  printFilters = () => {
    return (
      <tr key="use_case_filters">
        {this.state.columnHeader.map((data, index) =>
          data.filter ? (
            <th key={index}>{this.printFilterInput(data)}</th>
          ) : (
            <th key={index}></th>
          )
        )}
      </tr>
    );
  };

  printFilterInput = (input) => {
    if (input.type === "text")
      return (
        <input
          name={input.key}
          type="text"
          onChange={this.formChangeHandler}
        ></input>
      );
    else if (input.type === "list" || input.type === "multiple-list")
      return (
        <select name={input.key} type="text" onChange={this.formChangeHandler}>
          <option value="">All</option>
          {this.printOptions(input.key)}
        </select>
      );
  };

  printOptions = (key) => {
    return (
      <React.Fragment>
        {this.state.filterValues[key].map((value) => (
          <option value={value}>{value}</option>
        ))}
      </React.Fragment>
    );
  };

  printRecords = () => {
    let items = this.state.filteredResults.slice(
      this.state.startIndex,
      this.state.endIndex + 1
    );

    return (
      <React.Fragment>
        {items.map((data) => (
          <tr key={data.id}>
            <td>{data.link}</td>
            <td>{data.name}</td>
            <td>{data.price}</td>
            <td>{data.bandwidth}</td>
            <td>{data.dedicated_account_manager}</td>
            <td>{data.over_100_countries}</td>
            <td>{data.residential_static}</td>
            <td>{data.residential_rotating}</td>
            <td>{data.locations}</td>
            <td>{data.username}</td>
            <td>{data.password}</td>
            <td>
              <MoreActions
                onEditClicked={() => this.toggleEdit(data)}
                item={data}
              />
            </td>
          </tr>
        ))}
      </React.Fragment>
    );
  };

  pagination = () => {
    return this.state.filteredResults.length > env.RECORDS_PER_PAGE ? (
      <div className="audit-trail-footer">
        <Pagination
          items={this.state.filteredResults}
          onChangePage={(pagination) => this.setState(pagination)}
          pageSize={env.RECORDS_PER_PAGE}
        />
      </div>
    ) : (
      ""
    );
  };

  toggleAddNew = () => {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };

  toggleEdit = (editable) => {
    this.setState({ editable });
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };

  printActions = () => {
    return (
      <React.Fragment>
        <button
          type="button"
          onClick={() => {
            let editable = {
              dedicated_account_manager: "Yes",
              over_100_countries: "Yes",
              residential_static: "Yes",
              residential_rotating: "Yes",
            };
            this.setState({ editable });
            this.toggleAddNew();
          }}
          className="btn btn-sm btn-primary"
        >
          {this.state.addTitle}
        </button>
      </React.Fragment>
    );
  };

  render() {
    return (
      <Container>
        <Row className="user-section">
          <Card className="table-section form">
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">{this.state.title}</h5>
                <div className="toolbar-buttons">{this.printActions()}</div>
              </div>
              <Table
                responsive
                hover
                className="table--head-accent table--bordered"
              >
                <thead>
                  <tr>
                    {this.state.columnHeader.map((data) => (
                      <th key={data.key}>{data.name}</th>
                    ))}
                  </tr>
                  {this.printFilters()}
                </thead>
                <tbody>{this.printRecords()}</tbody>
              </Table>
              {this.pagination()}
            </CardBody>
          </Card>
        </Row>
        <Slider
          isOpen={this.state.isOpen}
          footer={
            <div className="button-container">
              <button
                className="square btn btn-primary btn-sm"
                onClick={() => this.submit()}
                type="button"
              >
                Submit
              </button>
              <button
                type="button"
                className="square btn btn-danger btn-sm"
                onClick={() => this.toggleAddNew()}
              >
                Cancel
              </button>
            </div>
          }
          onOutsideClick={() => this.setState({ isOpen: false })}
        >
          {
            <FormComponent
              title={
                this.state.editable !== undefined &&
                this.state.editable.slug !== undefined &&
                this.state.editable.slug.trim() !== ""
                  ? this.state.editTitle
                  : this.state.addTitle
              }
              toggleAddNew={this.toggleAddNew}
              handleForm={(formValues) => this.handleForm(formValues)}
              edit={() => {
                return this.state.editable;
              }}
            />
          }
        </Slider>
        <Modal
          onClose={() => this.setState({ show: false })}
          show={this.state.show}
          errors={this.state.errors}
          success={this.state.success}
        ></Modal>
      </Container>
    );
  }
}

export default ResidentialProxies;
